import SvgNewPostIcon from "jsx:../../../Images/Icons/FontAwesome/solid/image.svg";
import { SvgIcon, SxProps } from "@mui/material";

export function ImageSolidIcon(props: SxProps) {
    return (
        <SvgIcon
            component={SvgNewPostIcon}
            inheritViewBox
            sx={{
                color: "var(--community-color-primary-text)",
                ...props,
            }}
        />
    );
}
